// Only english for now!
export const toOrdinal = (n: number): string => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const roundNumberToNext = (n: number, next = 100) => {
  return Math.ceil(n / next) * next;
};
